import { isStructureEditable as isEventStructureEditable } from '@/components/events/eventLifecycle';
import { StacksManager } from '@/components/shared/stacks/StacksManager';
import { useEventContext } from '@/pages/events/useEventContext';
import { Skeleton } from '@startupquickstart/frontend';

/**
 * Event Stacks tab — thin wrapper around the shared owner-scoped
 * StacksManager (also used by TemplateStacksTab). With `keyPrefix='Event'`
 * and `apiBase=/events/:id` the manager's query keys and endpoints are
 * byte-identical to this tab's original inline implementation.
 */
export function EventStacksTab() {
  const { event, isLoading } = useEventContext();

  if (isLoading || !event) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 rounded-xl" />
        <Skeleton className="h-32 rounded-xl" />
      </div>
    );
  }

  return (
    <StacksManager
      ownerId={event.id}
      apiBase={`/events/${event.id}`}
      keyPrefix="Event"
      structureEditable={isEventStructureEditable(event.status)}
    />
  );
}
